import { XTableApi } from '../components/x/table-api/XTableApi';
import React from 'react';
import { useAsync, useCheckboxes } from '@orderx/lab/ui';

type Options = {
    runOnInit?: boolean;
    mapCellByType?: { [key: string]: any };
};

export function useApiTable(apiQuery: any, options?: Options) {
    const query = useAsync(apiQuery, { runOnInit: options?.runOnInit });

    const checkboxes = useCheckboxes(
        query.result?.table?.body?.rows?.map((row) => row.cells.find((cell) => cell.type === 'CHECKBOX')) || [],
        { mapValue: (model) => model.value },
    );

    return {
        query,
        checkboxes,
        table: <XTableApi query={query} checkboxes={checkboxes} mapCellByType={options?.mapCellByType} />,
    };
}
